import React from 'react';
import { InputProps } from '.';

export type InputContextProps = InputProps & {
  inPrefix?: boolean;
  inSuffix?: boolean;
};

export const InputContext = React.createContext<InputContextProps | null>(null);
